import { Component, createElement, createRef, h } from "preact";
import { faMapMarkerAlt, faPen, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BranchModal from "./BranchModal";

export default class BranchSelection extends Component {
    modalRef = createRef();

    constructor(props) {
        super();
        this.state = {
            selected_store: window.tccdata.stores[window.tccdata.selected_store_id],
            accordionOpened: false,
        };
        this.handleStoreChange = this.handleStoreChange.bind(this);

        // this is bad and should probably use a global state handler instead but whatever
        // will listen for any branch modification event to update all branchselection internal states
        window.addEventListener(
            "branchModified",
            (e) => {
                this.handleStoreChange();
            },
            false
        );

        const self = this;

        // Add in compatibility for zenoti integration
        window.showLocationModal = function showLocationModal() {
            self._toggle();
        };
        // End zenoti integration
    }

    componentDidMount() {
        document.addEventListener("openBranchModal", this.toggle, false);
    }

    componentWillUnmount() {
        document.removeEventListener("openBranchModal", this.toggle, false);
    }

    render(props, state) {
        return (
            <div class={state.accordionOpened ? "gumnut-store-locator__opened" : null}>
                <a
                    href={this.props.href}
                    onClick={(e) => this._toggle()}
                    class={"gumnut-store-selector header-item" + (state.selected_store ? " header-item-active" : "")}
                >
                    <div className={"header-item__wrapper"}>
                        <span className={"gumnut-store-selector-icon header-item__icon-wrapper"}>
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                        </span>
                        {!state.selected_store && this.renderSelectStore(state)}
                        {state.selected_store && this.renderSelectedStore(state)}
                    </div>
                    <div className={"gumnut-store-selector-edit header-item__edit"}>
                        <FontAwesomeIcon icon={faPen} />
                    </div>
                </a>

                {this.renderMobileAccordion(state)}
                {this.renderModal(state)}
            </div>
        );
    }

    renderModal(state) {
        return <BranchModal onChanged={this.handleStoreChange} selectedStore={state.selectedStore} ref={this.modalRef} />;
    }

    renderMobileAccordion(state) {
        if (!state.selected_store) {
            return <div></div>;
        }
        return (
            <div className="gumnut-store-locator__mobile-accordion">
                <h4>{state.selected_store.branchName}</h4>
                <span className="gumnut-store-locator__store-address">{state.selected_store.address}</span>
                <a
                    class={"btn btn-tcc-blue text-white mt-3"}
                    href={
                        "tel:" +
                        state.selected_store.contactNumber
                            .replaceAll("(", "")
                            .replaceAll(")", "")
                            .replaceAll(" ", "")
                    }
                >
                    <FontAwesomeIcon className={"mr-2"} icon={faPhoneAlt} />
                    {state.selected_store.contactNumber}
                </a>
                <a onClick={(e) => this._openAccordion()} class={"btn btn-grey text-white mt-3"}>
                    <FontAwesomeIcon className={"mr-2"} icon={faPen} />
                    Change Your Preferred Store
                </a>
            </div>
        );
    }

    renderSelectedStore(state) {
        return (
            <div class={"gumnut-store-selector-content header-item__content-wrapper"}>
                <span>Your Preferred Store</span>
                <span>{state.selected_store.branchName}</span>
            </div>
        );
    }

    renderSelectStore(state) {
        return (
            <div class={"gumnut-store-selector-content header-item__content-wrapper"}>
                <span>Select Your Store</span>
                <span>for pricing & availability</span>
            </div>
        );
    }

    _openAccordion() {
        this.modalRef.current.toggle();
    }

    _toggle() {
        if (window.innerWidth <= 991 && this.state.selected_store) {
            this.setState({
                accordionOpened: !this.state.accordionOpened,
            });
        } else {
            this._openAccordion();
        }
    }

    handleStoreChange() {
        this.setState(
            {
                selected_store: window.tccdata.stores[window.tccdata.selected_store_id],
            },
            this.forceUpdate
        );
    }
}
